import { generateRest } from "../utils";

export interface ApiArticleObject {
  id: number;
  name: string;
  content: string;
  position?: number;
}

export default generateRest<ApiArticleObject>('admin/articles');